var track_store = "us"
jQuery(document).ready(function($) {
  $('#order-tracking-form').submit(function(e) {
    e.preventDefault();
    var $form = $(this);
    if ($form.hasClass('loading')) return;
    $('.track-order-result,#track-order-result-success,#track-order-result-error').hide();
    $form.addClass('loading');
    
    var order_track_field = $form.find('[name="order_track_field"]').val();
    var brand = $form.find('[name="order_brand"]').val();
    function showTrackingError(message) {
      $('#track-order-result-error').html('<p>' + message + '</p>').show();
      $('.track-order-result').show();
    }
    var unavailableMessage = 'Sorry, we could not load your tracking details. Please try again or contact us for help.';
    $.ajax({
      url: 'https://minetanbodyskin.com/order-tracking/get.php',
      dataType: 'json',
      data: {order_track_field: order_track_field, store: track_store, brand: brand},
      timeout: 20000
    }).done(function(data) {
      try {
      if (!data || (data.success == 1 && !Array.isArray(data.orders))) {
        showTrackingError(unavailableMessage);
        return;
      }
      if(data.success == 1) {
        var is_single_order = (data.orders.length == 1);
        if(is_single_order) {
        	$('#track-order-result-success h2 > .order-num').text(data.orders[0].order_number).css('display', 'inline');          
            $('#track-order-result-success table thead th').first().hide();
        } else {
          	$('#track-order-result-success h2 > .order-num').attr('style', '');   
            $('#track-order-result-success table thead th').first().attr('style', '');
        }
        
        var html = '';
        var html_m = '';
        var $rows_holder = $('#track-order-holder');
        var $rows_holder_m = $('#track-order-holder-mobile');
        for(var i in data.orders) {
          var order_num = data.orders[i].order_number;
          if(data.orders[i].fulfillments.length>0) {
            for(var j in data.orders[i].fulfillments) {
              var fulfillment = data.orders[i].fulfillments[j];
              var tracking_carrier = (fulfillment.tracking_company !== null) ? fulfillment.tracking_company : 'UPS';      
              if(fulfillment.tracking_numbers.length>0) {  
              	var tracking_numbers = fulfillment.tracking_numbers[0].split(',');
              }
              var tracking_link = tracking_url = '';
              if(typeof fulfillment.tracking_urls[0] !== 'undefined') {
                tracking_url = fulfillment.tracking_urls[0];
              	tracking_link = '<a href="'+tracking_url+'" target="_blank">'+tracking_carrier+'</a>';
              } else if(typeof tracking_numbers !== 'undefined' && tracking_carrier === 'UPS') {
                tracking_url = 'https://www.ups.com/WebTracking?loc=en_US&requester=ST&trackNums='+tracking_numbers.join('%20');
                tracking_link = '<a href="'+tracking_url+'" target="_blank">'+tracking_carrier+'</a>';
              }
              for(var k in fulfillment.line_items) {
                var item = fulfillment.line_items[k];
              	html += '<tr>';
                html += '	<td'+(is_single_order ? 'style="display:none;"' : '')+'>'+order_num+'</td>';
                html += '	<td>'+item.name+'</td>';
                html += '	<td>'+item.quantity+'</td>';
                var tn = typeof tracking_numbers !== 'undefined' ? tracking_numbers.join('<br>') : '&ndash;';
                html += '	<td>'+tn+'</td>';
                var tl = tracking_link !== '' ? tracking_link : '&ndash;';
                html += '	<td>'+tl+'</td>';
                html += '</tr>';

                html_m += '<div class="item">';
                html_m += '	<div class="sub-item"'+(is_single_order ? 'style="display:none;"' : '')+'><div class="item-name">'+$('#to-column-name-1').text()+'</div><span>'+order_num+'</span></div>';
                html_m += '	<div class="sub-item"><div class="item-name">'+$('#to-column-name-2').text()+'</div><span>'+item.name+'</span></div>';
                html_m += '	<div class="sub-item"><div class="item-name">'+$('#to-column-name-3').text()+'</div><span>'+item.quantity+'</span></div>';
                html_m += '	<div class="sub-item"><div class="item-name">'+$('#to-column-name-4').text()+'</div><span>'+tn+'</span></div>';
                html_m += '	<div class="sub-item"><div class="item-name">'+$('#to-column-name-5').text()+'</div><span>'+tl+'</span></div>';
                html_m += '</div>';
              }
            }
          }
        }
        
        var $link = $('.track-order-links a');
        if(is_single_order && typeof tracking_url !== 'undefined') {
          var href = $link.attr('href');
          $link.attr('data-old-href', href);
          $link.attr('href', tracking_url); 
        } else if($link.attr('data-old-href') != '') {
          $link.attr('href', $link.attr('data-old-href'));         	
        }
        $rows_holder.html(html);
        if($rows_holder_m.length>0) {
          $rows_holder_m.html(html_m);
        }
        $('#track-order-result-success').show();
      } else {
        showTrackingError(data.error || unavailableMessage);
      }
      $('.track-order-result').show();
      } catch (error) {
        showTrackingError(unavailableMessage);
      }
    }).fail(function() {
      showTrackingError(unavailableMessage);
    }).always(function() {
      $form.removeClass('loading');
    });
    
  });
});